module.exports = __webpack_public_path__ + "img/en-gb.7795eb08.png";